function init(container) {
	// function parallaxScroll() {
	// 	const scrolled = $(window).scrollTop();
	// 	$('.first-images__mobile.for-desktop').css({
	// 		transform: 'translateY('+ (0 - (scrolled * .20)) +'px)'
	// 	});
	//
	// 	$('.first-images__clock').css({
	// 		transform: 'translateY('+ (0 - (scrolled * .4)) +'px)'
	// 	});
	// }

	function parallaxInit() {
		let $elem1 = $('#parallax-1');
		let $elem2 = $('#parallax-2');

		document.addEventListener('mousemove', parallax);
		// Magic happens here
		function parallax(e) {
			let _w = window.innerWidth/2;
			let _h = window.innerHeight/2;
			let _mouseX = e.clientX;
			let _mouseY = e.clientY;
			let depth1 = `${0 - (_mouseX - _w) * 0.005}%, ${0 - (_mouseY - _h) * 0.005}%`;
			let depth2 = `${0 - (_mouseX - _w) * 0.005}% ${0 - (_mouseY - _h) * 0.005}%`;
			let depth3 = `${0 - (_mouseX - _w) * 0.008}% ${0 - (_mouseY - _h) * 0.008}%`;

			$elem1.css({'transform':'translate('+ depth1 +')'});
			$elem2.css({'transform':'translate('+ depth1 +')'});

			console.log(depth3);
		}
	}

	if($(window).width() >= 1024 ) {
		parallaxInit();

		$(window).bind('scroll', function (e) {

		});
	}
}

function destroy(container) {
	$(window).unbind('scroll');
}

export default {
	init,
	destroy,
};
